 <div class="container container-extra">

        <app-back-nav class="mb-20" linkText="{{ 'GOAL_BASIC_SETTINGS.BACK_TO_GOALS' | translate }}" [link]="getBackLink()"></app-back-nav>

        <section class="page-title">
            <h1>{{ 'GOAL_BASIC_SETTINGS.GOAL_BASIC_DATA' | translate }}</h1>
            <div class="review-period-info" *ngIf="data">{{ data.reviewPeriod.name }} | {{ data.reviewPeriod.startDate | datePlain }} - {{ data.reviewPeriod.endDate | datePlain }}</div>
        </section>

        <mat-card *ngIf="isError" class="card-light error-panel">
            <mat-card-title>{{ 'GOAL_BASIC_SETTINGS.ERROR' | translate }}</mat-card-title>
            <mat-card-content>
                {{ errorMessage }}<br>
            </mat-card-content>
        </mat-card>

        <form [formGroup]="mainForm" *ngIf="!isError">
            <mat-card class="card-light">
                <mat-card-content>
    
                    <section class="amount-info">
                        <div class="section-title uppercase">{{ 'GOAL_BASIC_SETTINGS.BASE_AMOUNT' | translate }}</div>
                        <div class="flex-h gap-10">
                            <mat-form-field appearance="outline">
                                <mat-label>{{ 'GOAL_BASIC_SETTINGS.BASE_AMOUNT_LABEL' | translate }}</mat-label>
                                <input matInput formControlName="baseAmount" cdkFocusInitial mask="separator.0" thousandSeparator=" " [allowDecimal]="false" [allowNegativeNumbers]="false">
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="currency-select">
                                <mat-label>{{ 'GOAL_BASIC_SETTINGS.CURRENCY' | translate }}</mat-label>
                                <mat-select formControlName="currencyCode" disableOptionCentering class="drop-fix">
                                    <mat-option *ngFor="let item of currencyCodes" [value]="item.code">{{ item.code }} - {{ item.name }}</mat-option>
                                </mat-select>
                                <mat-error msg></mat-error>
                            </mat-form-field>
                        </div>
                    </section>

                    <section class="weighting-info">
                        <div class="section-title uppercase">{{ 'GOAL_BASIC_SETTINGS.WEIGHTING' | translate }}</div>

                        <mat-divider></mat-divider>

                        <div class="flex-h weight-row gap-10">
                            <div class="row-title uppercase">{{ 'GOAL_BASIC_SETTINGS.TEXT_BASED_INDIVIDUAL_GOALS' | translate }}</div>
                            <mat-form-field appearance="outline">
                                <mat-label>{{ 'GOAL_BASIC_SETTINGS.WEIGHTING_OPTIONAL' | translate }}</mat-label>
                                <input matInput formControlName="textBasedCustomWeight" decimalMarker="," mask="separator.2" [allowNegativeNumbers]="false">
                            </mat-form-field>
                        </div>
                        <div class="flex-h weight-row gap-10">
                            <div class="row-title uppercase">{{ 'GOAL_BASIC_SETTINGS.QUANTITATIVE_INDIVIDUAL_GOALS' | translate }}</div>
                            <mat-form-field appearance="outline">
                                <mat-label>{{ 'GOAL_BASIC_SETTINGS.WEIGHTING_OPTIONAL' | translate }}</mat-label>
                                <input matInput formControlName="numericCustomWeight" decimalMarker="," mask="separator.2" [allowNegativeNumbers]="false">
                            </mat-form-field>
                        </div>
                        <div class="flex-h weight-row gap-10">
                            <div class="row-title uppercase">{{ 'GOAL_BASIC_SETTINGS.COMPETENCY_EVALUATION_RESULT' | translate }}</div>
                            <mat-form-field appearance="outline">
                                <mat-label>{{ 'GOAL_BASIC_SETTINGS.WEIGHTING_OPTIONAL' | translate }}</mat-label>
                                <input matInput formControlName="competencyWeight" decimalMarker="," mask="separator.2" [allowNegativeNumbers]="false">
                            </mat-form-field>
                        </div>
                    </section>

                </mat-card-content>
                <mat-card-actions>
                    <button mat-flat-button color="primary" class="ml-10" (click)="save()">{{ 'GENERAL.OK' | translate }}</button>
                    <button mat-flat-button color="accent" class="ml-10" (click)="cancel()">{{ 'GENERAL.CANCEL' | translate }}</button>
                </mat-card-actions>
            </mat-card>

        </form>
</div>
